module.exports = __webpack_public_path__ + "media/application/images/bonington_short-term-loans-d2a44e2f00fef27ecc72a4992c973e43.png";